import { useQuery } from "@tanstack/react-query";
import type { User } from "../types";
import { userApi } from "../api/user.api";
import { userQueryKeys } from "./userQueryKeys";

/** For `queryClient.fetchQuery` / `ensureQueryData` — keeps cache keys aligned with `useUserByIdQuery`. */
export function userByIdQueryOptions(userId: string) {
  return {
    queryKey: userQueryKeys.detail(userId),
    queryFn: (): Promise<User> => userApi.getUser(userId),
  };
}

export function useUserByIdQuery(userId: string | undefined, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: userQueryKeys.detail(userId),
    queryFn: () => userApi.getUser(userId!),
    enabled: !!userId && (options?.enabled ?? true),
  });
}
